import './CarouselStyling.module.css'

import React from 'react'

import { CarouselComponent, ContentCard, CtaButton } from '../../components'
import useMediaQuery from '../../hooks/useMediaQuery'
import { useTeamData } from '../../hooks/useTeamData'
import { SectionContainer } from '../../layouts'
import { ContentParser, hasNulls } from '../../utils/helpers'
import {
  // buttonClassName,
  cardContainer,
  cardContent,
  contentCardFooter,
  contentClassName,
  ctaButtonStyling,
  doctorsContentContainerMobile,
  doctorsHeader,
  doctorsLight,
  // extraDecsriptionStyling,
  // sectionControls,
  swiperSlide,
} from './DoctorsSection.module.css'

const NewDoctorsSection = ({ lang, slice }) => {
  const { teamcarousel, teamcontent, teamheading, teamkicker } = slice

  const hasOwnData = slice?.hasowndata || false

  const data = useTeamData()
  const { teamdata } = data.filter((item) => item.language.slug === lang)[0]
    .teamdata
  const isDesktop = useMediaQuery('(min-width: 961px)')
  let doctors = ContentParser(teamdata, 'doctor').filter(
    (res) => !hasNulls(Object.values(res)),
  )
  if (hasOwnData) {
    const { teamcards } = slice
    doctors = teamcards.nodes.map((item) => {
      return {
        ...item?.teamcardFields,
        cta:
          lang === 'nl'
            ? item?.teamcardFields?.cta_nl
            : item?.teamcardFields?.cta_en,
      }
    })
  }
  // let ctaContent = teamsectioncta
  // if (typeof teamsectioncta === 'string') {
  //   ctaContent = JSON.parse(teamsectioncta)
  // }
  return (
    <SectionContainer
      extraClassName={doctorsLight}
      extraDescriptionClassName={contentClassName}
      extraHeaderClassName={doctorsHeader}
      extraHeadingContainerClassName={doctorsContentContainerMobile}
      heading={teamheading}
      kicker={teamkicker}
      renderedContent={teamcontent}
      withHeader
    >
      {/* <div className={sectionControls}>
        {teamsectioncta && (
          <CtaButton
            wide
            {...ctaContent}
            extraClassName={buttonClassName}
            type="secondary"
          />
        )}
      </div> */}
      {doctors && teamcarousel && (
        <CarouselComponent isDesktop={isDesktop} withoutNav={false}>
          {doctors.map((doctor, index) => {
            const { cta, image, name, title } = doctor
            let ctaButton = cta
            if (typeof cta === 'string') {
              ctaButton = JSON.parse(cta)
            }
            return (
              // eslint-disable-next-line react/no-array-index-key
              <div key={index} className={`${swiperSlide} ${cardContainer}`}>
                <ContentCard
                  content={title}
                  doctors
                  extraClassName={cardContent}
                  extraContentCardStyle={contentCardFooter}
                  image={image}
                  title={name}
                />
                <CtaButton {...ctaButton} extraClassName={ctaButtonStyling} />
              </div>
            )
          })}
        </CarouselComponent>
      )}
    </SectionContainer>
  )
}

export default NewDoctorsSection
